export const logAppVersions = () => {
  // eslint-disable-next-line no-console -- Log required for QA
  console.log(
    `%c Frontend version (Vite): ${import.meta.env.VITE_REACT_APP_VERSION}`,
    'background: #000; color: #fff; font-size: 18px;',
  )
}
